/* global $ */
/* eslint-env browser */

import Swiper from "swiper";

let $carousel_greencare;
let swiperAPIGreencare;
// let mql1;
// let mql2;
// let mql3;

function init() {
    $carousel_greencare = $(".banner-carousel-greencare");

    if (!$carousel_greencare.length) {
        return;
    }

    // // mql1 = window.matchMedia("(min-width: 640px)");
    // // mql2 = window.matchMedia("(min-width: 1400px)");
    // // mql3 = window.matchMedia("(min-width: 1700px)");

    // Initial state
    resizeHandler();

    // // Resize
    // mql1.addListener(resizeHandler);
    // mql2.addListener(resizeHandler);
    // mql3.addListener(resizeHandler);
}

function resizeHandler() {
    destroySwiper();
    createSwiper();
}

function createSwiper() {
    // const slidesLength = $carousel_greencare.find('.swiper-slide').length;
    // let shouldInitCarousel = true;

    // if (
    // 	(mql3.matches && slidesLength <= 4)
    // 	|| (mql2.matches && slidesLength <= 3)
    // 	|| (mql1.matches && slidesLength <= 2)
    // ) {
    // 	shouldInitCarousel = false;
    // } else if (slidesLength === 1) {
    // 	shouldInitCarousel = false;
    // }

    // if (!shouldInitCarousel) return;

    swiperAPIGreencare = new Swiper(
        $carousel_greencare.find(".swiper-container-greencare")[0],
        {
            autoHeight: true,
            roundLengths: true,
            loop: true,
            // If we need pagination
            autoplay: 5000,
            prevButton: $carousel_greencare.find(
                ".banner-carousel__control.control--prev"
            )[0],
            nextButton: $carousel_greencare.find(
                ".banner-carousel__control.control--next"
            )[0],
            pagination: $carousel_greencare.find(".swiper-pagination")[0],
            // paginationElement: "button",
            paginationClickable: true,
            autoHeight: true,
            slidesPerView: 1,
            breakpoints: {
                639: {
                    slidesPerView: 1,
                },
                1400: {
                    slidesPerView: 1,
                },
                1700: {
                    slidesPerView: 1,
                },
            },
            onInit: () => {
                $carousel_greencare.addClass("is-ready");
            },
        }
    );
    console.log("greencare");
}

function destroySwiper() {
    if (swiperAPIGreencare) {
        $carousel_greencare.removeClass("is-ready");
        swiperAPIGreencare.destroy(true, true);
        swiperAPIGreencare = null;
    }
}

export default {
    init,
};
